import Platform from "@/config/platform";
import { Storage } from "@/uitls/Storage";
import { Dialog, Toast } from "vant";
import { base64Encode, fbqEvent, googleEvent, scqEvent, ttqEvent } from "./uitls";
import EventBus from "./EventBus";

export function pickQueryParam(route, key: string): string | undefined {
    const raw = route.query[key];
    if (Array.isArray(raw)) {
      return raw[0];
    }
    return raw as string | undefined;
}

//处理query参数
// export function cheackQuery(route) {
//     const { os, uid, fastkey, customerId, token, channel } = route.query;
//     if (os && os != "h5") {
//         Platform.client = os as string;
//         Storage.set("customerId", customerId);
//         Storage.set("token", token);
//     }
//     if (uid && uid !== "" && uid !== 0) {
//         Storage.set("uid", uid);
//         Storage.set("fastkey", fastkey);
//     }
//     if (channel) {
//         Platform.channel = channel
//     }
// }

export function cheackQuery(route) {
    
    const os      = pickQueryParam(route, 'os');
    const uid     = pickQueryParam(route, 'uid');
    const fastkey = pickQueryParam(route, 'fastkey');
    const customerId = pickQueryParam(route, 'customerId');
    const token   = pickQueryParam(route, 'token');
    const channel = pickQueryParam(route, 'channel');
  
    if (os && os !== 'h5') {
      Platform.client = os;
      Storage.set('customerId', customerId);
      Storage.set('token', token);
    }
    if (uid) {
      Storage.set('uid', uid);
      Storage.set('fastkey', fastkey);
    }
    if (channel) {
      Platform.channel = Number(channel);
    }
}

export function checkInvite(route) {
    const { invite_code } = route.query;
    // alert(invite_code)
    if (invite_code && invite_code !== '') {
        Platform.from_invite_code = invite_code + '';
    }
}
//调用原生，去登录页面
export function nativeToLogin(router = null, refresh = false) {
    if (Platform.client == "h5") {
        EventBus.emit('showLogin', { refresh });
    } else if (window.android && window.android.toLogin) {
        window.android.toLogin()
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.ToLogin.postMessage("");
    }
}

// 检测账号是否登录或设置用户昵称等信息
export function checkSetNickname(fname: string, phone: string): boolean {
    if (Platform.client == "h5") {
        const isPhone = phone && phone.length > 3;
        const isAcc = fname && fname.length > 0;
        if (isAcc) {
            return true;
        }

        EventBus.emit(isPhone ? 'showSetNickName' : 'showLogin');
        return false;
    }
    return true;
}

//调用原生，去系统浏览器
export function toLocationBrowser(path: string) {
    window.$apiNet.statisticsPost({ action_id: 23 });
    if (Platform.client == "h5") {
        // return window.location.href = path;
        return window.open(path, '_blank')
    } else if (window.android && window.android.toBrowser) {
        window.android.toBrowser(path)
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.ToOutsideWeb.postMessage(path);
    }
}

//安卓投屏
export function toRemotePlay(path: string) {
    if (window.android && window.android.toRemotePlay) {
        window.android.toRemotePlay(path)
    }
}


//调用原生，新起一个窗口
export function nativeToNewWeb(router, path: string) {

    //获取域名
    let baseUrl = window.location.origin;
    // let pathname = window.location.pathname;
    // baseUrl = `${baseUrl}${pathname}#`
    const customerId = Storage.get("customerId");
    const token = Storage.get("token");
    // console.log('baseUrl', baseUrl);
    //测试本地域名
    // baseUrl = 'http://192.168.8.126:3000/#' 
    if (Platform.client == "h5") {
        return router.push(path)
    }
    if (window.android && window.android.toWeb) {
        // Toast.success(path + `&os=android&customerId=${customerId}&token=${token}`)
        window.android.toWeb(baseUrl + path + `&os=android&customerId=${customerId}&token=${token}`, null)
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.ToNewWeb.postMessage(baseUrl + path + `&os=ios&customerId=${customerId}&token=${token}`);
    }
}

//调用原生返回页面
export function ToBack(router) {
    
    if (Platform.client == "h5") {
        return router.back()
    } else if (window.android && window.android.toBack) {
        window.android.toBack()
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.VCBack.postMessage('');
    }
}

//调用原生，信封出来了，去消息列表
export function toMsgList(router) {
    if (Platform.client == "h5") {
        router.push("/message?type=1");
    } else if (window.android && window.android.toMessage) {
        window.android.toMessage()
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.TransParm.postMessage('envelope');
    }
}
//调用原生，跳到私聊
export function toMsgChat(router, uid, chatkey, msgs = []) {
    let data = encodeURIComponent(base64Encode(encodeURIComponent(JSON.stringify(msgs))));
    const str = uid.toString();
    if (Platform.client == "h5") {
        router.push(`/chat/?id=${chatkey}&msgs=${data}`)
    } else if (window.android && window.android.toChat) {

        window.android.toChat(JSON.stringify({ uid: uid, msgs: data }))
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.ChatAnchor.postMessage(str);
    }
}

//调用原生，到个人资料
export function toSetting(router) {
    if (Platform.client == "h5") {
        router.push('/Setting')
    } else if (window.android && window.android.toEditInfo) {
        window.android.toEditInfo()
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.TransParm.postMessage('profile');
    }
}

//调用原生，回到首页
export function goHome(router) {
    if (Platform.client == "h5") {
        router.replace('/')
    } else if (window.android && window.android.toHome) {
        window.android.toHome()
    } else if (window && window.webkit && window.webkit.messageHandlers && Platform.client == 'ios') {
        window.webkit.messageHandlers.TransParm.postMessage('index');
    }
}

// 下载App
export function toDownloadApp(webClip?: boolean) {
    let ios = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    let downurl = '';
    if (ios) {
        if (webClip) {
            downurl = Platform.downUrlWebclip;
            const u = getiOSVersion();
            if (u < 17.0) {
                // 指引webclip安装
                setTimeout(() => {
                    Dialog.alert({
                        title: '添加到主屏幕',
                        message: '即将为您跳转到安装界面',
                    }).then(() => {
                        // on close
                        toLocationBrowser(Platform.downMobileprovision);
                    });
                }, 1000);
            }
        } else {
            downurl = Platform.downUrlIos;
            if (downurl == '') {
                return toDownloadApp(true);
            }
        }
    } else {
        downurl = Platform.downUrlAndroid;
    }
    toLocationBrowser(downurl);
    window.$apiNet.statisticsPost(1);
    fbqEvent('trackCustom', 'ToDownload');
    googleEvent('event', 'ToDownload');
    scqEvent('click_download');
    ttqEvent('ToDownload');
}


function getiOSVersion() {
    const match = navigator.userAgent.match(/(iPhone|iPad|iPod).*?OS (\d+[._]\d+)/i);
    if (match) {
        const version = match[2].replace('_', '.');
        return parseFloat(version);
    }
    return null;
}